jQuery(document).ready(function($){

    if ($('.corporate-page-slider .slider-container').length > 0){

        $('.corporate-page-slider .slider-container').slick({
            dots: false,
            infinite: true,
            slidesToShow: 6,
            // variableWidth: true,
            autoplay: false,
            slidesToScroll: 1,
            prevArrow: '<i class="slick-arrow left fas fa-chevron-left"></i>',
            nextArrow: '<i class="slick-arrow right fas fa-chevron-right"></i>',

            responsive: [
                {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                }
                },
                {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
                },
                {
                breakpoint: 567,
                settings: {
                    slidesToShow: 1,
                }
                }
               
            ]
        });

        grabCorporateData(0, $('.corporate-page-slider').data('post-id'));

        $('.corporate-partner').click(function(){

            var counter = $(this).data('partner-counter');
            var post_id = $('.corporate-page-slider').data('post-id');

            grabCorporateData(counter, post_id);

            $('.corporate-partner').removeClass('active');
            $(this).addClass('active');
        });
    }

    $('.corporate-page-slider .slider-container').on('afterChange', function(event, slick, currentSlide, nextSlide){
        
        if (window.matchMedia("(max-width: 657px)").matches) {
            
            var active_slide = $('.corporate-partner.active ');
            
            grabCorporateData(currentSlide, $('.corporate-page-slider').data('post-id'));

          } 

      });

    function grabCorporateData(counter, post_id){
                
        ThemeJS.Functions.send_ajax_request({
            

            data: {
                action: 'get_corporate_partner_data',
                counter: counter,
                post_id: post_id
            },
            success: ( data ) => {

                $('.success-filter-content').html('<p>' + data.success_story + '</p>');
                $('.carousel-inner').html('');
                var counter = 1;
                $.each(data.testimonials, function(index, value){
                    var active_class = "";
                    if (counter == 1){  
                        active_class = 'active';
                    }

                    var star_html = '';

                    for( var i = 0; i < 5; i++){
                        if (value.testimonial_rating >= i){
                            star_html+= '<span class="fas fa-star"></span>';
                        }
                        else{
                            star_html+= '<span class="fal fa-star"></span>'
                        }
                    }


                    $('.carousel-inner').append(
                        `
                        <div class="carousel-item ${active_class}">
                            <p>${value.testimonial_copy}</p>
                            <h3 class="name">${value.testimonial_name}</h3>
                            <div class="star-container">${star_html}</div>
                        </div>
                        `
                    );
                    counter++;
                    
                });

                $('.match-content-height').matchHeight();
                $('.filtered-inner').matchHeight();
    
            },
            error: ( data ) => {
               console.log( 'error!' );
            }
        });
    }

    $('.corporate-two-column-section .column h3').matchHeight();
    $('.corporate-two-column-section .column p').matchHeight();
    $('.corporate-two-column-section .corporate-event').matchHeight();


});